/* I LOVE DUFT — Product page (PDP) enhancements
   1) Premium accordions: smooth open/close (CSS grid-rows) + single class toggle
   2) Add-to-cart price sync: mirrors the live price block into the button on variant change */
(function () {
  'use strict';

  /* ---------- Accordions ---------- */
  function initAccordions(scope) {
    var accs = (scope || document).querySelectorAll('[data-ild-acc]');
    Array.prototype.forEach.call(accs, function (acc) {
      if (acc.dataset.ildAccInit === '1') return;
      acc.dataset.ildAccInit = '1';
      var btn = acc.querySelector('.ild-acc__summary');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Price inside the Add-to-cart button ---------- */
  function readPrice(priceEl) {
    if (!priceEl) return '';
    // Prefer the sale price when a product is on sale, else the regular price.
    var node = null;
    if (priceEl.querySelector('.price--on-sale')) {
      node = priceEl.querySelector('.price-item--sale');
    }
    if (!node) node = priceEl.querySelector('.price-item--regular');
    if (!node) node = priceEl.querySelector('.price-item');
    return node ? node.textContent.trim() : '';
  }

  function initPriceSync(root) {
    var sectionEl = root.querySelector('[id^="price-"]');
    if (!sectionEl) return;
    var sectionId = sectionEl.id.replace('price-', '');
    var target = root.querySelector('#ild-atc-price-' + sectionId);
    if (!target) return;

    var sync = function () {
      var val = readPrice(sectionEl);
      if (val) target.textContent = val;
    };

    var obs = new MutationObserver(sync);
    obs.observe(sectionEl, { childList: true, subtree: true, characterData: true });
    sync();
  }

  function initAll() {
    initAccordions(document);
    document.querySelectorAll('product-info').forEach(initPriceSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is reloaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initAccordions(e.target);
    var pi = e.target.querySelector ? e.target.querySelector('product-info') : null;
    if (pi) initPriceSync(pi);
  });
})();
